import { createContext, useState } from 'react';
import * as React from 'react';

import { translate } from '~l10n/client';
import { atom, useAtomValue } from 'jotai';

import { AllowCloseContext, Dialog } from '~shared/components/Dialog';
import { Pending } from '~teacher/components/ExportReports/ExportFeedback/ExportFeedbackIcons';
import {
  CurrentQuizEditorDialog,
  currentQuizEditorDialogAtom,
} from '~teacher/components/QuizEditor/atoms/currentQuizEditorDialogAtom';
import { ImportFromText } from '~teacher/components/QuizEditor/ImportFromTextDialog/ImportFromText';
import { HideIntercomLauncher } from '~teacher/hook/utils/HideIntercomLauncher';

export const positionAtom = atom(1);

const SetAllowCloseContext =
  createContext<(allowClose: boolean) => void>(undefined);

export function useSetAllowClose() {
  const setAllowCloseContext = React.useContext(SetAllowCloseContext);
  if (!setAllowCloseContext) {
    throw new Error(
      'useSetAllowClose must be used within a SetAllowCloseContext'
    );
  }
  return setAllowCloseContext;
}

interface Props {
  onClose: () => void;
  onSuccess: () => void;
}

export function ImportFromTextDialog({ onClose, onSuccess }: Props) {
  const currentQuizEditorDialog = useAtomValue(currentQuizEditorDialogAtom);

  const [allowClose, setAllowClose] = useState(true);

  const handleClose = () => {
    onClose();
  };

  return (
    <SetAllowCloseContext.Provider value={setAllowClose}>
      <AllowCloseContext.Provider value={allowClose}>
        <Dialog
          position="right"
          showBackdrop={false}
          size="medium"
          open={
            currentQuizEditorDialog === CurrentQuizEditorDialog.ImportFromText
          }
          onClose={handleClose}
          id={'generate-quiz-dialog'}
          title={translate('Copy-Paste Questions')}
          closeLabel={translate('Close')}
        >
          {() =>
            currentQuizEditorDialog ===
            CurrentQuizEditorDialog.ImportFromText ? (
              <>
                <HideIntercomLauncher />
                <ImportFromText onSuccess={onSuccess} />
              </>
            ) : (
              <div className="grid items-center justify-center h-full">
                <div className="flex flex-col items-center gap-8">
                  <Pending />
                </div>
              </div>
            )
          }
        </Dialog>
      </AllowCloseContext.Provider>
    </SetAllowCloseContext.Provider>
  );
}
